<h1 matDialogTitle>{{modalTitle}}</h1>

<form form="confirmEmailForm" autocomplete="off" novalidate fxLayoutGap="10px">
<mat-dialog-content style="width: 360px" fxLayout="column">
  <span>
    We've noticed that your account does not have an email address, or the email address is invalid.<br/>
    Please update your email address
  </span><br/>
    <mat-form-field fxFlex="100">
      <input matInput appNoWhiteSpace autocomplete="off" type="email" placeholder="Email" [formControl]="frmEmail">
      <mat-error *ngIf="frmEmail.hasError('required')">
        Email is required
      </mat-error>
      <mat-error *ngIf="frmEmail.hasError('email')">
        Please provide a valid email address
      </mat-error>
    </mat-form-field>
  </mat-dialog-content>

  <mat-dialog-actions>
    <button mat-raised-button color="primary" type="submit" (click)="onSubmitForm()" [disabled]="!frmEmail.valid">Submit</button>
  </mat-dialog-actions>
</form>
